/* ============================================================
   androidFacebook.js — robot FACEBOOK APP PHONE (Draft sahaja buat masa ini)
   ============================================================
   Keputusan user 4 Nov 2026 (PLAN_PHONE_TIKTOK_FB.md):
   - Reel (video) DENGAN / TANPA link produk Shopee · post gambar · post text.
   - AI label ON/OFF ikut pilihan. SEMUA = simpan DRAFT.
   Diukur pada Redmi 14C, FB `com.facebook.katana` (profile + page "Viral Johor").

   Ukuran penting:
   - Hampir semua skrin FB boleh dibaca (content-desc jelas). Editor reel (video
     main) TIDAK → butang Next = kedudukan (650,1420 pada 720×1640).
   - "Add product" (link produk) HANYA ada bila post sebagai PAGE, bukan profile
     peribadi. Banner produk Shopee perlu page itu "Connect your affiliate account"
     (sekali, oleh pemilik — robot TIDAK menekannya; robot tekan "Not now" →
     link tetap masuk sebagai sticker, tanpa banner).
   - Bukti draft reel = "Start a Drafts reel, N" naik +1. Draft post (gambar/text)
     TIADA kiraan yang ditemui → bukti = dialog "Want to finish your post later?"
     → Save as Draft → kembali ke Home.
   - Robot TUKAR ke page (penukar profile) bila diminta, dan PULANG ke identiti
     asal di akhir larian (supaya app pelanggan kekal seperti asal).
   ⛔ "Share now" / "Post" — robot TIDAK menekannya (Draft sahaja).
   ============================================================ */

import {
  delay, bacaSkrinSelamat, tunggu, ketuk, cariKetuk, shell,
  dialogSistem, teksSelamat, taipTepat, urlSelamat, keyboardNaik, gambarTerbaru,
} from './androidDumpKit';
import { buatPenyasar } from './androidAjar';

export const FB_PKG = 'com.facebook.katana';
const POS = { menu: [0.907, 0.908], reelNext: [0.903, 0.866], atas: [0.5, 0.09] };

const LANGKAH = {
  launch: { labelEn: 'Open Facebook', labelMs: 'Buka Facebook' },
  switch_page: { labelEn: 'Switch to your page', labelMs: 'Tukar ke page' },
  open_reel: { labelEn: 'Open reel creator', labelMs: 'Buka cipta reel' },
  pick_video: { labelEn: 'Select video', labelMs: 'Pilih video' },
  editor_next: { labelEn: 'Confirm edit', labelMs: 'Sahkan edit' },
  caption: { labelEn: 'Write caption', labelMs: 'Isi caption' },
  product_link: { labelEn: 'Add Shopee link', labelMs: 'Tambah link Shopee' },
  open_post: { labelEn: 'Open post creator', labelMs: 'Buka cipta post' },
  write_text: { labelEn: 'Write text', labelMs: 'Tulis text' },
  pick_images: { labelEn: 'Select images', labelMs: 'Pilih gambar' },
  post_next: { labelEn: 'Open post settings', labelMs: 'Buka tetapan post' },
  ai_label: { labelEn: 'AI label', labelMs: 'AI label' },
  save_draft: { labelEn: 'Save draft', labelMs: 'Simpan draft' },
  verify_draft: { labelEn: 'Confirm draft saved', labelMs: 'Sahkan draft tersimpan' },
  restore_profile: { labelEn: 'Switch back', labelMs: 'Tukar balik' },
};

export function facebookSteps(content = 'video', { page = '', link = false } = {}) {
  const ids = ['launch'];
  if (page) ids.push('switch_page');
  if (content === 'video') {
    ids.push('open_reel', 'pick_video', 'editor_next', 'caption');
    if (link) ids.push('product_link');
    ids.push('ai_label', 'save_draft', 'verify_draft');
  } else {
    ids.push('open_post', 'write_text');
    if (content === 'image') ids.push('pick_images');
    ids.push('post_next', 'ai_label', 'save_draft');
  }
  if (page) ids.push('restore_profile');
  return ids.map((id) => ({ id, ...LANGKAH[id] }));
}

const sz = (ctl) => [ctl?.info?.screenWidth || 720, ctl?.info?.screenHeight || 1640];
const ketukNisbah = async (ctl, [rx, ry], ms = 1500) => {
  const [w, h] = sz(ctl);
  await ctl.tap(Math.round(rx * w), Math.round(ry * h));
  await delay(ms);
};
const butangCipta = (e) => e.clickable && /^Create, double-tap/.test(e.desc);
const skrinReel = (e, els) => e.desc === 'Save as Draft' && els.some((x) => /^Describe your reel/.test(x.desc));
const kotakTeksPost = (els) => els.find((e) => /EditText|AutoComplete/.test(e.cls) && e.b.y1 < 700);

/* FB memulihkan composer/reel yang tertinggal walaupun app ditutup paksa (diukur 4 Nov).
   Kemas: tutup skrin terbuka; dialog simpan → SENTIASA "Save as Draft" (⛔ tidak pernah
   Discard — mungkin kerja pelanggan sendiri). */
async function kemasSkrin(ctl) {
  for (let k = 0; k < 5; k++) {
    const els = await bacaSkrinSelamat(ctl);
    if (els && els.some(butangCipta)) return true;
    const simpan = els && els.find((e) => e.clickable && (e.text === 'Save as Draft' || e.text === 'SAVE AS DRAFT'));
    const baru = els && els.find((e) => e.clickable && e.text === 'START A NEW REEL');
    const tutup = els && els.find((e) => e.clickable && (e.desc === 'Close' || e.desc === 'Cancel' || e.desc === 'Back' || e.desc === 'Go back') && e.b.y1 < 200);
    if (simpan) await ketuk(ctl, simpan, 3500);
    else if (baru) await ketuk(ctl, baru, 3000);
    else if (tutup) await ketuk(ctl, tutup, 2500);
    else { await ctl.back(); await delay(2000); }
  }
  return !!(await tunggu(ctl, butangCipta, 3000));
}

// Home dengan butang Create kelihatan. Feed ter-scroll menyorok header (diukur 4 Nov) →
// scroll ke atas; masih tiada → buka semula FB (Home sentiasa bermula di atas).
async function keHome(ctl) {
  let r = await tunggu(ctl, butangCipta, 8000);
  if (r) return r;
  // Bukan feed (composer / reel / dialog tertinggal) → kemas dahulu.
  const els0 = await bacaSkrinSelamat(ctl);
  const bukanFeed = els0 && els0.some((e) => e.clickable && (
    ((e.desc === 'Close' || e.desc === 'Cancel' || e.desc === 'Back' || e.desc === 'Go back') && e.b.y1 < 200)
    || e.text === 'Save as Draft' || e.text === 'SAVE AS DRAFT' || e.text === 'START A NEW REEL'));
  if (bukanFeed && await kemasSkrin(ctl)) return tunggu(ctl, butangCipta, 3000);
  r = await tunggu(ctl, butangCipta, 1500);
  if (r) return r;
  const [w, h] = sz(ctl);
  for (let k = 0; k < 3 && !r; k++) {
    await ctl.swipe(Math.round(w / 2), Math.round(h * 0.3), Math.round(w / 2), Math.round(h * 0.85), 300);
    await delay(900);
    r = await tunggu(ctl, butangCipta, 1500);
  }
  if (r) return r;
  await shell(ctl, ['am', 'force-stop', FB_PKG]);
  await delay(700);
  await ctl.launchApp(FB_PKG);
  await delay(7000);
  await cariKetuk(ctl, (e) => e.text === 'START A NEW REEL' && e.clickable, 1500, 2000);
  return tunggu(ctl, butangCipta, 10000);
}

// Penukar profile: pulang nama identiti yang sedang aktif (baris bertanda dipilih).
// S = ketukSasar (androidAjar) — tangga ajaran pelanggan → default → minta pelanggan tunjuk.
async function bukaPenukar(ctl, S) {
  const sw = (e) => e.clickable && /^Open profile switcher/.test(e.desc);
  const menu = await S('fb.menu_tab', 'Menu tab', 'Switch to your page', {
    pos: POS.menu, sahkan: async () => { await delay(2500); return !!(await tunggu(ctl, sw, 5000)); },
  });
  if (!menu.ok) return null;
  return (await S('fb.profile_switcher', 'Profile switcher', 'Switch to your page', {
    pred: sw, ms: 4000, sahkan: async () => !!(await tunggu(ctl, (e) => e.clickable && e.selected && e.desc, 5000)),
  })).ok;
}
async function tukarIdentiti(ctl, nama, S) {
  if (!(await bukaPenukar(ctl, S))) return { ok: false, sebab: 'Penukar profile FB tak dijumpai.' };
  // Senarai identiti (diukur 4 Nov): baris boleh klik, desc "Nama, N notifications"; yang aktif = selected.
  const r = await tunggu(ctl, (e) => e.clickable && e.selected && e.desc, 5000);
  const els = r ? r.els : (await bacaSkrinSelamat(ctl)) || [];
  const baris = els.filter((e) => e.clickable && e.desc && e.b.y1 > 300 && !/^Create Facebook Page|^Dismiss/.test(e.desc));
  const asal = baris.find((e) => e.selected) || null;
  const namaRow = (e) => e.desc.split(',')[0].trim();
  if (asal && namaRow(asal).toLowerCase() === String(nama).trim().toLowerCase()) {
    await ctl.back(); await delay(1200); await ctl.back(); await delay(1200);
    return { ok: true, asal: namaRow(asal) };
  }
  const sasaran = baris.find((e) => namaRow(e).toLowerCase() === String(nama).trim().toLowerCase());
  if (!sasaran) { await ctl.back(); await delay(1000); return { ok: false, sebab: `Page "${nama}" tak dijumpai dalam akaun FB di phone.` }; }
  await ketuk(ctl, sasaran, 8000);
  return { ok: true, asal: asal ? namaRow(asal) : '' };
}

// Kiraan draft reel = nombor LENCANA dalam petak Drafts (teks). ⚠️ content-desc
// "Start a Drafts reel, N" kadang lambat dikemas kini (diukur 4 Nov: desc 3, lencana 4).
async function bacaDraftReel(ctl) {
  const d = await tunggu(ctl, (e) => /^Start a Drafts reel/.test(e.desc), 6000);
  if (!d) return null;
  const t = d.el.b;
  const lencana = d.els.find((e) => /^\d+$/.test(e.text) && e.b.x1 >= t.x1 && e.b.x2 <= t.x2 && e.b.y1 >= t.y1 && e.b.y2 <= t.y2);
  const m = d.el.desc.match(/,\s*(\d+)/);
  return Math.max(lencana ? Number(lencana.text) : 0, m ? Number(m[1]) : 0);
}

// Buka landing "Create reel" dari Home. "Continue editing / Start a new reel" → mula baru.
const menuCipta = (e) => e.clickable && ['Post', 'Story', 'Reel', 'Live'].includes(e.desc);
async function bukaMenuCipta(ctl, S, langkah) {
  return (await S('fb.create', 'Create button', langkah, {
    pred: butangCipta, ms: 8000, sahkan: async () => !!(await tunggu(ctl, menuCipta, 4000)),
  })).ok;
}
async function bukaLandingReel(ctl, S) {
  if (!(await bukaMenuCipta(ctl, S, 'Open reel creator'))) return 'Butang Create FB tak dijumpai.';
  if (!(await S('fb.menu_reel', 'Reel option', 'Open reel creator', {
    pred: (e) => e.desc === 'Reel' && e.clickable, ms: 5000,
    sahkan: async () => { await delay(2500); return !(await tunggu(ctl, menuCipta, 1500)); },
  })).ok) return 'Pilihan Reel tak dijumpai.';
  // Reel lama belum habis → dialog (boleh muncul lambat), dua rupa diukur 4 Nov:
  //   A. "CONTINUE EDITING / START A NEW REEL" (juga "Continue editing your latest draft?") → START A NEW REEL
  //   B. "Continue editing your last reel?" CONTINUE EDITING / SAVE AS DRAFT / DISCARD
  //      → SAVE AS DRAFT (⛔ jangan DISCARD — mungkin kerja pelanggan sendiri).
  const dialog = (e) => e.clickable && (e.text === 'START A NEW REEL' || e.text === 'SAVE AS DRAFT');
  const sasaran = (e) => dialog(e) || /^Start a Drafts reel/.test(e.desc) || e.desc === 'Allow Access';
  let r = await tunggu(ctl, sasaran, 12000);
  if (r && dialog(r.el)) {
    await ketuk(ctl, r.el, 3500);
    r = await tunggu(ctl, (e) => /^Start a Drafts reel/.test(e.desc) || e.desc === 'Allow Access', 10000);
  }
  if (!r) return 'Skrin cipta reel tak terbuka.';
  if (r.els.some((e) => e.desc === 'Allow Access')) return 'Facebook belum dibenarkan akses galeri — tekan "Allow Access" sendiri di phone sekali, kemudian Run semula.';
  return '';
}

async function pastikanSkrinReel(ctl) {
  for (let k = 0; k < 3; k++) {
    if (await tunggu(ctl, skrinReel, 4000)) return true;
    const els = await bacaSkrinSelamat(ctl);
    // Tersangkut di "Add a product link" → Back (link dibatalkan; pemanggil lapor).
    if (els && els.some((e) => e.text === 'Add a product link' || e.desc === 'Add a product link')) { await ctl.back(); await delay(2500); continue; }
    if (els && els.length <= 3 && els.some((e) => e.desc === 'Close')) { await ketukNisbah(ctl, POS.atas, 2000); continue; } // popup penerangan
    if (!els) { await ketukNisbah(ctl, POS.reelNext, 5000); continue; } // kembali ke editor (video main)
    await ketukNisbah(ctl, POS.atas, 2000);
  }
  return !!(await tunggu(ctl, skrinReel, 3000));
}

/* runFacebookPhone(controller, cfg, cb)
   cfg.params = { content:'video'|'image'|'text', caption, text, aiLabel, fbPage:'' (kosong = profile),
                  productLink (reel sahaja; kosong = tiada link), imageNames:[…] } */
export async function runFacebookPhone(controller, cfg = {}, cb = {}) {
  const ctl = controller;
  const p = cfg.params || {};
  const content = ['image', 'text'].includes(p.content) ? p.content : 'video';
  const aiLabel = p.aiLabel !== false;
  const page = String(p.fbPage || '').trim();
  const link = content === 'video' ? urlSelamat(p.productLink) : '';
  if (content === 'video' && p.productLink && !link) cb.onLog?.('Link produk tidak sah — dilangkau.', 'warn');
  const steps = facebookSteps(content, { page, link: !!link });
  const total = steps.length;
  const onStep = typeof cb.onStep === 'function' ? cb.onStep : () => {};
  const log = (m, l = 'info') => cb.onLog?.(m, l);
  if (!ctl?.connected) return { status: 'failed', reason: 'not-connected' };
  if (!ctl.info) { try { await ctl.getDeviceInfo(); } catch { /* biar */ } }
  // Ajar robot (4 Nov): kunci 'fb.*' = NAMA TETAP butang (storan + ayat sokongan).
  const { ketukSasar } = buatPenyasar({
    ctl, appId: 'facebook', log,
    ajaran: cfg.ajar?.ajaran, mintaAjar: cfg.ajar?.mintaAjar, paksaGagal: cfg.ajar?.paksaGagal,
  });
  const S = (kunci, label, langkah, o) => ketukSasar(kunci, { label, langkah, ...o });

  let draftAwal = null; let diPost = false; let asal = '';
  const belumSiap = [];
  const nota = []; // makluman untuk pelanggan (bukan ralat), cth "page tiada AI label"
  const gagal = (id, reason) => ({ id, reason });

  const jalan = {
    launch: async () => {
      await shell(ctl, ['am', 'force-stop', FB_PKG]);
      await delay(700);
      await ctl.launchApp(FB_PKG);
      await delay(7000);
      if (await dialogSistem(ctl)) return gagal('launch', 'Ada popup kebenaran Android di phone — tekan sendiri, kemudian Run semula.');
      if (!(await keHome(ctl))) return gagal('launch', 'Home Facebook tak terbuka (belum login atau ada popup).');
      return null;
    },
    switch_page: async () => {
      const t = await tukarIdentiti(ctl, page, S);
      if (!t.ok) return gagal('switch_page', t.sebab);
      asal = t.asal;
      if (!(await keHome(ctl))) return gagal('switch_page', 'Home FB tak terbuka selepas tukar ke page.');
      log(`Post sebagai page "${page}".`);
      return null;
    },
    open_reel: async () => {
      const e = await bukaLandingReel(ctl, S);
      if (e) return gagal('open_reel', e);
      draftAwal = await bacaDraftReel(ctl);
      log(`Draft reel sedia ada: ${draftAwal}`);
      return null;
    },
    pick_video: async () => {
      if (!(await S('fb.reel_video', 'Newest video in gallery', 'Select video', {
        pred: (e) => e.clickable && /^Create reel with Video, item/.test(e.desc), ms: 6000,
        sahkan: async () => { await delay(5000); return !(await tunggu(ctl, (e) => /^Start a Drafts reel/.test(e.desc), 1500)); },
      })).ok) return gagal('pick_video', 'Video tak dijumpai dalam galeri FB.');
      return null;
    },
    editor_next: async () => {
      // Editor reel (video main) tak boleh dibaca → kedudukan. Sah = skrin butiran reel.
      const r = await S('fb.reel_next', 'Next button (reel editor)', 'Confirm edit', {
        pos: POS.reelNext, sahkan: async () => { await delay(3500); return pastikanSkrinReel(ctl); },
      });
      if (!r.ok) return gagal('editor_next', 'Skrin butiran reel FB tak terbuka.');
      diPost = true;
      return null;
    },
    caption: async () => {
      const cap = teksSelamat(p.caption, 2000);
      if (!cap) { log('Caption kosong — dilangkau.', 'warn'); return null; }
      const r = await tunggu(ctl, (e) => /^Describe your reel/.test(e.desc) && e.clickable, 5000);
      if (!r) return gagal('caption', 'Kotak caption reel tak dijumpai.');
      const capT = /#[^\s#]+$/.test(cap) ? cap + ' ' : cap;
      const h = await taipTepat(ctl, capT, {
        ketukKotak: () => ketuk(ctl, r.el, 1000),
        bacaKotak: async () => { const x = await bacaSkrinSelamat(ctl); const k = x && x.find((e) => /^Describe your reel/.test(e.desc)); return k ? k.text : null; },
      }, log);
      if (await keyboardNaik(ctl)) { await ctl.back(); await delay(1200); }
      if (!(await pastikanSkrinReel(ctl))) return gagal('caption', 'Terkeluar dari skrin reel selepas caption.');
      if (!h.ok) return gagal('caption', `Caption tak masuk dengan tepat (${h.nota}).`);
      return null;
    },
    product_link: async () => {
      const row = await S('fb.add_product', 'Add product', 'Add Shopee link', {
        pred: (e) => e.clickable && /^Add product/.test(e.desc), ms: 4000,
        sahkan: async () => { await delay(3000); return !!(await tunggu(ctl, (e) => (/^URL/.test(e.desc) && e.clickable) || /^Create custom link/.test(e.desc), 5000)); },
      });
      if (!row.ok) return gagal('product_link', 'Tiada "Add product" — link produk hanya boleh pada PAGE (bukan profile).');
      // Page ADA partnership Shopee (diukur 4 Nov, "Himpunan Zikir & Doa"): skrin "Product links"
      // → "See all products" / "Create custom link" → borang sama. Page tanpa partnership terus ke borang.
      const custom = await tunggu(ctl, (e) => e.clickable && /^Create custom link/.test(e.desc), 3000);
      if (custom) await ketuk(ctl, custom.el, 4000);
      const f = await tunggu(ctl, (e) => /^URL/.test(e.desc) && e.clickable, 6000);
      if (!f) return gagal('product_link', 'Kotak URL produk tak dijumpai.');
      const h = await taipTepat(ctl, link, {
        mentah: true,
        ketukKotak: () => ketuk(ctl, f.el, 1000),
        bacaKotak: async () => { const x = await bacaSkrinSelamat(ctl); const k = x && x.find((e) => /^https?:\/\//.test(e.text)); return k ? k.text : null; },
      }, log);
      // Link name WAJIB diisi (diukur 4 Nov: tanpanya butang Save kekal kelabu + tiada
      // pilihan "Not now"). Teks yang penonton baca pada sticker/banner.
      const ln = await tunggu(ctl, (e) => /^Link name/.test(e.desc) && e.clickable, 4000);
      if (ln) {
        await taipTepat(ctl, teksSelamat(p.linkName || 'Beli di Shopee', 60), {
          ketukKotak: () => ketuk(ctl, ln.el, 1000),
          bacaKotak: async () => '',
        }, log);
      }
      if (await keyboardNaik(ctl)) { await ctl.back(); await delay(2500); }
      // Page tanpa akaun affiliate disambung → "Connect your account / Not now". Robot TIDAK
      // menyambung akaun (OAuth = pemilik). "Not now" → link masuk sebagai sticker.
      // Partnership: pratonton "This affiliate link may appear as a banner" → Save → kembali ke
      // "Product links" (link tersenarai) → Save lagi. Tiada partnership: "Connect your account /
      // Not now" → robot pilih Not now (link jadi sticker, tiada banner).
      const lepas = await tunggu(ctl, (e) => e.text === 'Not now' || e.desc === 'Not now' || /^Link preview/.test(e.desc), 6000);
      if (lepas && /^Link preview/.test(lepas.el.desc)) log('Page ada partnership Shopee — link boleh keluar sebagai banner.', 'ok');
      if (lepas && (lepas.el.text === 'Not now' || lepas.el.desc === 'Not now')) {
        await ketuk(ctl, lepas.el, 3000);
        log('Banner Shopee perlu "Connect your account" pada page ini (sekali, oleh pemilik). Link masuk tanpa banner.', 'warn');
        nota.push('Page ini belum sambung akaun affiliate Shopee di Facebook — link masuk tanpa banner.');
      } else {
        for (let k = 0; k < 4; k++) { // Save boleh kelabu sekejap (FB semak link)
          await cariKetuk(ctl, (e) => e.desc === 'Save' && e.clickable, 3000, 3500);
          if (!(await tunggu(ctl, (e) => /^URL/.test(e.desc) && e.clickable, 1500))) break;
          await delay(2000);
        }
        // Skrin "Product links" (partnership) → Save sekali lagi untuk kembali ke reel.
        if (await tunggu(ctl, (e) => /affiliate product link/i.test(e.desc), 3000)) await cariKetuk(ctl, (e) => e.desc === 'Save' && e.clickable, 3000, 4000);
      }
      if (!(await pastikanSkrinReel(ctl))) return gagal('product_link', 'Tak kembali ke skrin reel selepas link produk.');
      if (!h.ok) return gagal('product_link', `Link produk tak masuk dengan tepat (${h.nota}).`);
      return null;
    },
    open_post: async () => {
      if (!(await bukaMenuCipta(ctl, S, 'Open post creator'))) return gagal('open_post', 'Butang Create FB tak dijumpai.');
      if (!(await S('fb.menu_post', 'Post option', 'Open post creator', {
        pred: (e) => e.desc === 'Post' && e.clickable, ms: 5000,
        sahkan: async () => !!(await tunggu(ctl, (e, els) => !!kotakTeksPost(els) && e === kotakTeksPost(els), 8000)),
      })).ok) return gagal('open_post', 'Composer post FB tak terbuka.');
      diPost = true;
      return null;
    },
    write_text: async () => {
      const teks = teksSelamat(content === 'text' ? (p.text || p.caption) : p.caption, 5000);
      if (!teks) {
        if (content === 'text') return gagal('write_text', 'Card tiada teks untuk post text.');
        log('Caption kosong — dilangkau.', 'warn'); return null;
      }
      const r = await tunggu(ctl, (e, els) => e === kotakTeksPost(els), 5000);
      if (!r) return gagal('write_text', 'Kotak teks post tak dijumpai.');
      const t = /#[^\s#]+$/.test(teks) ? teks + ' ' : teks;
      const h = await taipTepat(ctl, t, {
        ketukKotak: () => ketuk(ctl, r.el, 1000),
        bacaKotak: async () => { const x = await bacaSkrinSelamat(ctl); const k = x && kotakTeksPost(x); return k ? k.text : null; },
      }, log);
      await cariKetuk(ctl, (e) => e.desc === 'Done' && e.clickable, 3000, 2000);
      if (!h.ok) return gagal('write_text', `Teks tak masuk dengan tepat (${h.nota}).`);
      return null;
    },
    pick_images: async () => {
      const nama = (p.imageNames || []).filter(Boolean);
      if (!nama.length) return gagal('pick_images', 'Tiada gambar dihantar ke phone.');
      if (!(await S('fb.post_gallery', 'Gallery button', 'Select images', {
        pred: (e) => e.desc === 'Gallery' && e.clickable, ms: 5000,
        sahkan: async () => { await delay(2500); return !!(await tunggu(ctl, (e) => /^Photo, item \d+/.test(e.desc), 6000)); },
      })).ok) return gagal('pick_images', 'Butang Gallery tak dijumpai.');
      // Galeri PAGE bermula mod pilih-satu dengan butang "Select multiple" (selected=true bila
      // hidup); galeri profile terus pilih-banyak (tiada butang). Diukur 4 Nov.
      const sm = await tunggu(ctl, (e) => e.desc === 'Select multiple' && e.clickable, 2500);
      if (sm && !sm.el.selected) {
        await ketuk(ctl, sm.el, 1500);
        if (!(await tunggu(ctl, (e) => e.desc === 'Select multiple' && e.selected, 3000))) return gagal('pick_images', '"Select multiple" tak dapat dihidupkan.');
      }
      const terbaru = await gambarTerbaru(ctl, nama.length);
      const kedudukan = nama.map((n) => terbaru.indexOf(n));
      if (kedudukan.some((i) => i < 0 || i >= nama.length)) return gagal('pick_images', 'Gambar card bukan gambar terbaru dalam galeri phone. Run semula.');
      for (const i of kedudukan) {
        const re = new RegExp(`^Photo, item ${i + 1},`);
        if (!(await cariKetuk(ctl, (e) => e.clickable && re.test(e.desc), 5000, 1300))) return gagal('pick_images', `Gambar ke-${i + 1} dalam galeri tak dijumpai.`);
      }
      const n = nama.length;
      const sah = await tunggu(ctl, (e) => new RegExp(`^Selected media, item ${n} of ${n}`).test(e.desc), 4000);
      if (!sah) return gagal('pick_images', `Bilangan gambar dipilih tak sama (${n}).`);
      if (!(await S('fb.gallery_next', 'Next button (gallery)', 'Select images', {
        pred: (e) => e.desc === 'Next' && e.clickable, ms: 4000,
        sahkan: async () => !!(await tunggu(ctl, (e) => new RegExp(`^Photo 1 of ${n}`).test(e.desc), 8000)),
      })).ok) return gagal('pick_images', 'Gambar tak masuk ke composer.');
      return null;
    },
    post_next: async () => {
      // Dua rupa (diukur 4 Nov): PROFILE = pratonton + butang "Post" bawah;
      // PAGE = "Post settings" + "SHARE" atas + Scheduling options.
      const r = await S('fb.post_next', 'Next button (post)', 'Open post settings', {
        pred: (e) => (e.desc === 'Next' || e.text === 'Next') && e.b.y1 > 1300, ms: 5000,
        sahkan: async () => { await delay(3000); return !!(await tunggu(ctl, (e) => (e.desc === 'Post' && e.clickable) || e.text === 'Post settings' || (e.desc === 'SHARE' && e.clickable), 8000)); },
      });
      if (!r.ok) return gagal('post_next', 'Skrin tetapan post tak terbuka.');
      return null;
    },
    ai_label: async () => {
      const reel = content === 'video';
      const baris = (e) => e.clickable && (reel ? /^Add AI label/.test(e.desc) : e.desc === 'AI label');
      let ai = await tunggu(ctl, baris, 3000);
      if (!ai) {
        const [w, h] = sz(ctl);
        await ctl.swipe(Math.round(w / 2), Math.round(h * 0.75), Math.round(w / 2), Math.round(h * 0.35), 500);
        await delay(1500);
        ai = await tunggu(ctl, baris, 4000);
      }
      if (!ai) {
        // Post TEXT, dan post GAMBAR sebagai PAGE, TIADA AI label dalam app FB (diukur 4 Nov —
        // "Post settings" page tiada suis itu). Bukan ralat: langkau + beritahu pelanggan.
        const sebagaiPage = !!(await tunggu(ctl, (e) => e.text === 'Post settings' || (e.desc === 'SHARE' && e.clickable), 1500));
        if (!aiLabel || content === 'text' || sebagaiPage) {
          if (aiLabel) nota.push(content === 'text' ? 'Post text Facebook tiada pilihan AI label.' : 'Post gambar sebagai Page Facebook tiada pilihan AI label (hanya Reel / profile).');
          log('Tiada suis AI label pada skrin ini — dilangkau.', 'warn');
          return null;
        }
        return gagal('ai_label', 'Suis AI label tak dijumpai.');
      }
      if (ai.el.checked !== aiLabel) { await ketuk(ctl, ai.el, 1800); ai = await tunggu(ctl, (e) => baris(e) && e.checked === aiLabel, 4000); }
      if (!ai) return gagal('ai_label', `AI label tak dapat di${aiLabel ? 'hidupkan' : 'matikan'}.`);
      log(`AI label ${aiLabel ? 'ON' : 'OFF'}.`);
      return null;
    },
    save_draft: async () => {
      if (content === 'video') {
        if (!(await pastikanSkrinReel(ctl))) return gagal('save_draft', 'Skrin reel tiada.');
        const pilihanSimpan = (e) => e.clickable && /^Save as draft\. It will be removed/.test(e.desc);
        if (!(await S('fb.reel_save_draft', 'Save as Draft button', 'Save draft', {
          pred: (e) => e.desc === 'Save as Draft' && e.clickable, ms: 4000,
          sahkan: async () => !!(await tunggu(ctl, pilihanSimpan, 4000)),
        })).ok) return gagal('save_draft', 'Butang Save as Draft tak dijumpai.');
        if (!(await S('fb.reel_save_draft_option', '"Save as draft" option', 'Save draft', {
          pred: pilihanSimpan, ms: 4000,
          sahkan: async () => { await delay(4000); return true; },
        })).ok) return gagal('save_draft', 'Pilihan simpan draft tak dijumpai.');
        await ketukNisbah(ctl, POS.atas, 1500); // tutup sheet
        // Keluar dengan BETUL: Back → editor → Back → landing "Create reel" (tiada dialog).
        // ⛔ Jangan force-stop di sini: reel yang masih terbuka akan disimpan SEKALI LAGI
        // (dialog "Continue editing…" → draf berganda, diukur 4 Nov: 1 → 3).
        await ctl.back(); await delay(3000);
        await ctl.back(); await delay(3000);
        return null;
      }
      // Post: Back (profile "Back" / page "Go back") ke composer → Close →
      // "Want to finish your post later?" → Save as Draft.
      await cariKetuk(ctl, (e) => (e.desc === 'Back' || e.desc === 'Go back') && e.clickable && e.b.y1 < 200, 4000, 2500);
      if (!(await cariKetuk(ctl, (e) => e.desc === 'Close' && e.clickable && e.b.y1 < 200, 5000, 2500))) return gagal('save_draft', 'Butang tutup composer tak dijumpai.');
      if (!(await tunggu(ctl, (e) => /Want to finish your post later/.test(e.text || e.desc), 5000))) return gagal('save_draft', 'Dialog simpan draft FB tak muncul.');
      if (!(await cariKetuk(ctl, (e) => e.text === 'Save as Draft' && e.clickable, 3000, 4000))) return gagal('save_draft', 'Pilihan Save as Draft tak dijumpai.');
      if (!(await keHome(ctl))) return gagal('save_draft', 'Tak kembali ke Home selepas simpan draft.');
      log('Draft post disimpan (bukti: dialog FB "Save as Draft" + kembali ke Home).', 'ok');
      return null;
    },
    verify_draft: async () => {
      // Biasanya sudah di landing "Create reel" selepas save_draft (Back × 2).
      // ⚠️ Kiraan boleh lambat beberapa saat (diukur 4 Nov: baca terus = 0, buka semula = 1).
      let n = (await tunggu(ctl, (e) => /^Start a Drafts reel/.test(e.desc), 5000)) ? await bacaDraftReel(ctl) : null;
      for (let k = 0; k < 3 && !(n != null && draftAwal != null && n >= draftAwal + 1); k++) {
        await cariKetuk(ctl, (x) => x.desc === 'Cancel' && x.clickable, 2500, 2500);
        await delay(4000);
        if (!(await keHome(ctl))) return gagal('verify_draft', 'Home FB tak terbuka untuk sahkan draft.');
        const e = await bukaLandingReel(ctl, S);
        if (e) return gagal('verify_draft', e);
        n = await bacaDraftReel(ctl);
      }
      await cariKetuk(ctl, (x) => x.desc === 'Cancel' && x.clickable, 3000, 2500);
      if (n != null && draftAwal != null && n >= draftAwal + 1) { log(`Draft reel disahkan (${draftAwal} → ${n}).`, 'ok'); return null; }
      return gagal('verify_draft', 'Draft reel tak dapat disahkan (kiraan Drafts tak naik). Semak phone sebelum Run semula.');
    },
    restore_profile: async () => {
      if (!asal || asal.toLowerCase() === page.toLowerCase()) return null;
      await keHome(ctl); // termasuk buka semula FB bila larian gagal di tengah
      const t = await tukarIdentiti(ctl, asal, S);
      if (!t.ok) log(`Tak dapat tukar balik ke "${asal}": ${t.sebab}`, 'warn');
      return null;
    },
  };

  const pulih = async () => { if (page) await jalan.restore_profile().catch(() => {}); };
  for (let i = 0; i < total; i++) {
    const s = steps[i];
    onStep({ index: i, total, id: s.id, label: s.labelEn, status: 'running' });
    let err;
    try { err = await jalan[s.id](); } catch (e) { err = gagal(s.id, e?.message || String(e)); }
    if (!err) { onStep({ index: i, total, id: s.id, label: s.labelEn, status: 'pass' }); continue; }
    onStep({ index: i, total, id: s.id, label: s.labelEn, status: 'error', note: err.reason });
    log(`Gagal di "${s.labelEn}": ${err.reason}`, 'err');
    if (s.id === 'verify_draft') { await pulih(); return { status: 'failed', failedAt: 'finish', reason: err.reason, draftSaved: false }; }
    if (s.id === 'restore_profile') return { status: 'draft_saved', finishedAs: 'draft', nota };
    if (s.id === 'save_draft' || !diPost) { await pulih(); return { status: 'failed', failedAt: s.id, reason: err.reason, draftSaved: false }; }
    // Jaring Draft: sudah dalam composer → simpan Draft walaupun isi belum lengkap.
    steps.slice(i).forEach((x) => {
      if (x.id === 'caption' || x.id === 'write_text') belumSiap.push('caption');
      if (x.id === 'product_link') belumSiap.push('link Shopee');
      if (x.id === 'pick_images') belumSiap.push('gambar');
      if (x.id === 'ai_label') belumSiap.push('AI label');
    });
    if (content !== 'video' && steps.slice(i).some((x) => x.id === 'post_next')) {
      // Belum sampai / tersangkut di skrin tetapan: balik ke composer → tutup → Save as Draft.
      await cariKetuk(ctl, (e) => (e.desc === 'Back' || e.desc === 'Go back') && e.clickable && e.b.y1 < 200, 2500, 2500);
      await cariKetuk(ctl, (e) => e.desc === 'Close' && e.clickable && e.b.y1 < 200, 4000, 2500);
      const ok = await cariKetuk(ctl, (e) => e.text === 'Save as Draft' && e.clickable, 4000, 4000);
      await pulih();
      return ok
        ? { status: 'failed', finishedAs: 'draft', failedAt: s.id, reason: err.reason, draftSaved: true, belumSiap }
        : { status: 'failed', failedAt: s.id, reason: `${err.reason} · Draft juga gagal`, draftSaved: false };
    }
    const errD = await jalan.save_draft().catch((e) => gagal('save_draft', e?.message || e))
      || (content === 'video' ? await jalan.verify_draft().catch((e) => gagal('verify_draft', e?.message || e)) : null);
    await pulih();
    if (errD) return { status: 'failed', failedAt: s.id, reason: `${err.reason} · Draft juga gagal: ${errD.reason}`, draftSaved: false };
    return { status: 'failed', finishedAs: 'draft', failedAt: s.id, reason: err.reason, draftSaved: true, belumSiap, nota };
  }
  return { status: 'draft_saved', finishedAs: 'draft', nota };
}
